var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFingerTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3834 10.4235C9.77338 9.66029 8.65997 8.02017 8.65997 6.12C8.65997 3.49113 10.7911 1.36 13.42 1.36C16.0488 1.36 18.18 3.49113 18.18 6.12C18.18 8.02017 17.0666 9.66029 15.4566 10.4235",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.38 17C11.38 15.8732 10.4667 14.96 9.33999 14.96C8.21323 14.96 7.29999 15.8732 7.29999 17V21.76C7.29999 27.3931 11.8669 31.96 17.5 31.96C23.1331 31.96 27.7 27.3931 27.7 21.76V17C27.7 15.8732 26.7867 14.96 25.66 14.96C24.5332 14.96 23.62 15.8732 23.62 17V15.64C23.62 14.5132 22.7067 13.6 21.58 13.6C20.4532 13.6 19.54 14.5132 19.54 15.64V14.28C19.54 13.1532 18.6267 12.24 17.5 12.24C16.3732 12.24 15.46 13.1532 15.46 14.28V6.12C15.46 4.99324 14.5467 4.08 13.42 4.08C12.2932 4.08 11.38 4.99324 11.38 6.12V21.08V17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerTap);
export default __webpack_public_path__ + "static/media/fingerTap.1a20bfb8804177bbfadd3a3462bb8633.svg";
export { ForwardRef as ReactComponent };